import { MAP_ID_SET } from './mapId.actionTypes';

export const mapIdSet = (mapId: number | null) => ({
  type: MAP_ID_SET,
  payload: {
    mapId,
  },
}) as const;
